import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { CopyUtmParams } from "../copy-utm-params";

export const Facebook = () => (
  <div className="flex flex-col gap-3">
    <p className="mb-0">
      You will need to add UTM parameters to all <b>destination URLs</b> for new
      and existing ads.
    </p>
    <p className="mb-0">
      <b>Note:</b> Changing the tracking parameters for an existing ad will
      reset it to the learning phase. We recommend waiting for a low-traffic
      period to do so. You may choose to roll out UTM updates progressively, or
      you may &ldquo;rip off the bandaid&rdquo; and update all Facebook ads at
      once. If you decide to roll out updates progressively, please be aware
      that our reporting will be inaccurate until all updates are complete.
    </p>
    <p className="mb-0">
      <b>Note:</b> Northbeam will attempt to place UTM parameters on all newly
      created Facebook ads, but you will need to update your historic ads.
    </p>
    <p className="mb-0">Copy the following Northbeam parameters.</p>
    <CopyUtmParams
      className="my-3 max-w-2xl"
      platform={NorthbeamUtmPlatform.META}
      hideQuestionMark
      aggregateMultipleParams={false}
    />
    <p className="mb-0">
      Paste the text you copied above into the location provided in these
      instructions:{" "}
    </p>
    <iframe
      src="https://www.loom.com/embed/dfd6bbb850b2426eaaf8b74315986575"
      title="Facebook UTM tracking description"
      width="100%"
      height="500"
      frameBorder="0"
    />
  </div>
);
